type RouteMapping = {
    [key: string]: {
        en: string;
        pl: string;
        de: string;
    };
};

const routeMappings: RouteMapping = {
    'about': {
        en: 'about',
        pl: 'o-nas',
        de: 'uber-uns'
    },
    'contact': {
        en: 'contact',
        pl: 'kontakt',
        de: 'kontakt'
    },
    'sitemap': {
        en: 'sitemap',
        pl: 'mapa-witryny',
        de: 'sitemap'
    },
    'terms': {
        en: 'terms',
        pl: 'regulamin',
        de: 'agb'
    },
    'cookies': {
        en: 'cookies-policy',
        pl: 'polityka-cookies',
        de: 'cookie-richtlinie'
    },
    'privacy': {
        en: 'privacy-policy',
        pl: 'polityka-prywatnosci',
        de: 'datenschutz'
    },
    'blog': {
        en: 'blog',
        pl: 'blog',
        de: 'blog'
    },
    'forClinics': {
        en: 'for-clinics',
        pl: 'dla-przychodni',
        de: 'fur-kliniken'
    },
    'searchClinics': {
        en: 'search-clinics',
        pl: 'szukaj-przychodni',
        de: 'kliniken-suchen'
    }
};

export const getLocalizedPath = (path: string, language: string): string => {
    const cleanPath = path.startsWith('/') ? path.slice(1) : path;
    if (cleanPath === '') return `/${language}`;
    const mapping = routeMappings[cleanPath];
    if (mapping) {
        return `/${language}/${mapping[language as keyof typeof mapping]}`;
    }
    return `/${language}/${cleanPath}`;
};

export const getOriginalPath = (localizedPath: string, language: string): string => {
    const cleanPath = localizedPath.startsWith('/') ? localizedPath.slice(1) : localizedPath;
    if (cleanPath === '') return '/';
    
    // Remove language code from the path
    const pathWithoutLang = cleanPath.split('/').slice(1).join('/');
    
    for (const [originalPath, mappings] of Object.entries(routeMappings)) {
        if (mappings[language as keyof typeof mappings] === pathWithoutLang) {
            return `/${originalPath}`;
        }
    }
    return `/${pathWithoutLang}`;
}; 